/* eslint-disable jsx-a11y/alt-text */
import { findMap, findCiv } from '../helpers/drafting'
import classNames from 'classnames'

function getCivDetails(civs, draft) {
	if (draft)
		return draft.map((option) => ({
			...findCiv(option.civ, { withFallback: true }),
			...option,
		}))
	else return civs.map((civ) => findCiv(civ, { withFallback: true }))
}

export function MatchGameDraft({ game, gameNumber }) {
	const mapDetails = findMap(game.map, { withFallback: true })

	const leftCivDetails = getCivDetails(game.leftCivs, game.leftGameCivDraft)
	const rightCivDetails = getCivDetails(game.rightCivs, game.rightGameCivDraft)

	return (
		<div className={classNames('flex flex-row series-game', `series-${game.state}`)} data-game-number={gameNumber}>
			<div className="series-civPicks series-leftPicks">
				{leftCivDetails.map((draft, i) => {
					if (game.state !== 'picked')
						return (
							<div className="series-civContainer" key={`series-leftPicks-${i}`}>
								<img
									className={classNames(
										'series-civPick series-leftPick',
										draft.result === 'sniped' && 'series-civSniped',
										game.state === 'right' && 'series-civLose',
										game.state === 'left' && 'series-civWin',
									)}
									src={draft.draftFlagUrl}
								/>
								{draft.result !== 'sniped' && game.state === 'left' && <img className="series-winIcon" src="" alt="" />}
								{draft.result !== 'sniped' && game.state === 'right' && <img className="series-lossIcon" src="" alt="" />}
								{draft.result === 'sniped' && <img className="series-snipedIcon" src="" alt="" />}
							</div>
						)
				})}
			</div>

			<div className="series-mapContainer">
				<img className="series-map" src={mapDetails.iconUrl} />
			</div>

			<div className="series-civPicks series-rightPicks">
				{rightCivDetails.map((draft, i) => {
					if (game.state !== 'picked')
						return (
							<div className="series-civContainer" key={`series-rightPicks'${i}`}>
								<img
									className={classNames(
										'series-civPick series-rightPick',
										draft.action === 'sniped' && 'series-civSniped',
										game.state === 'left' && 'series-civLose',
										game.state === 'right' && 'series-civWin',
									)}
									src={draft.draftFlagUrl}
								/>
								{draft.result !== 'sniped' && game.state === 'right' && <img className="series-winIcon" src="" alt="" />}
								{draft.result !== 'sniped' && game.state === 'left' && <img className="series-lossIcon" src="" alt="" />}
								{draft.result === 'sniped' && <img className="series-snipedIcon" src="" alt="" />}
							</div>
						)
					else return null
				})}
			</div>
		</div>
	)
}
